import React from 'react';
import {CONSTANTS} from '../../ZoomImage.utils';
import {ZoomContext} from '../../index';
import {ZoomMenu as Component} from '@learningblocks/shared-components';

/**
 * ZoomMenu:
 *  - Component renders the ZoomIn/Out Controls for PopupZoomImage component
 */
export function ZoomMenu() {
  const {state, setZoom} = React.useContext(ZoomContext);

  return (
    <Component
      setZoom={setZoom}
      zoomValue={state.zoomValue}
      zoomRate={CONSTANTS.ZOOM_VALUE_RATE}
      maxZoom={CONSTANTS.MAX_ZOOM}
      minZoom={CONSTANTS.MIN_ZOOM}
      dropdownOptions={state.zoomDropdownOptions}
    />
  );
}
